import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _address = { geocode: '_addressLocation' };
var _addressLocation = {
    latitude: 'google.protobuf.DoubleValue',
    longitude: 'google.protobuf.DoubleValue',
};
var _getReservationLocationRequest = {};
var _getReservationLocationResponse = {
    reservationLocation: '_reservationLocation',
};
var _listReservationLocationsRequest = {};
var _listReservationLocationsResponse = {
    reservationLocations: '_reservationLocation',
};
var _location = { address: '_address' };
var _queryReservationLocationsRequest = {};
var _queryReservationLocationsResponse = {
    reservationLocations: '_reservationLocation',
};
var _reservationLocation = {
    createdDate: 'google.protobuf.Timestamp',
    updatedDate: 'google.protobuf.Timestamp',
    location: '_location',
};
var _updateExtendedFieldsRequest = {};
var _updateExtendedFieldsResponse = {
    reservationLocation: '_reservationLocation',
};
var _updateReservationLocationRequest = {
    mask: 'google.protobuf.FieldMask',
    reservationLocation: '_reservationLocation',
};
var _updateReservationLocationResponse = {
    reservationLocation: '_reservationLocation',
};
function resolveWixTableReservationsReservationLocationV1ReservationLocationsServiceUrl(opts) {
    var domainToMappings = {
        'www.wixapis.com': [
            {
                srcPath: '/table-reservations/reservation-locations',
                destPath: '',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/table-reservations/reservation-locations',
                destPath: '',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_api/table-reservations/reservation-locations',
                destPath: '',
            },
        ],
        'editor.wixapps.net': [
            {
                srcPath: '/_api/table-reservations/reservation-locations',
                destPath: '',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/table-reservations/reservation-locations',
                destPath: '',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_api/table-reservations/reservation-locations',
                destPath: '',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_api/table-reservations/reservation-locations',
                destPath: '',
            },
        ],
        _: [
            {
                srcPath: '/_api/table-reservations/reservation-locations',
                destPath: '',
            },
        ],
        '*.dev.wix-code.com': [
            {
                srcPath: '/_api/table-reservations/reservation-locations',
                destPath: '',
            },
        ],
        'apps._base_domain_': [
            {
                srcPath: '/_api/table-reservations/reservation-locations',
                destPath: '',
            },
        ],
        'api._api_base_domain_': [
            {
                srcPath: '/reservation-locations',
                destPath: '',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/** Retrieves a reservation location by ID. */
export function getReservationLocation(payload) {
    var _a = serializer(_getReservationLocationRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getReservationLocationResponse, {
        _address: _address,
        _addressLocation: _addressLocation,
        _location: _location,
        _reservationLocation: _reservationLocation,
    }).fromJSON;
    function __getReservationLocation(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.table_reservations.v1.reservation_location',
            method: 'GET',
            methodFqn: 'wix.table_reservations.reservation_location.v1.ReservationLocationsService.GetReservationLocation',
            url: resolveWixTableReservationsReservationLocationV1ReservationLocationsServiceUrl({
                protoPath: '/v1/reservation-locations/{reservationLocationId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getReservationLocation.fromReq = fromReq;
    __getReservationLocation.__isAmbassador = true;
    return __getReservationLocation;
}
/**
 * Updates a reservation location. Supports partial updates.
 *
 * Each time the reservation location is updated, `revision` increments by 1. The existing revision must be included when updating the reservation location. This ensures you're working with the latest reservation location information, and it prevents unintended overwrites.
 *
 * You cannot use this method to change a reservation location's `location` object. Attempting to do so will cause the server to return an application error.
 */
export function updateReservationLocation(payload) {
    var _a = serializer(_updateReservationLocationRequest, { _address: _address, _addressLocation: _addressLocation, _location: _location, _reservationLocation: _reservationLocation }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateReservationLocationResponse, {
        _address: _address,
        _addressLocation: _addressLocation,
        _location: _location,
        _reservationLocation: _reservationLocation,
    }).fromJSON;
    function __updateReservationLocation(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.table_reservations.v1.reservation_location',
            method: 'PATCH',
            methodFqn: 'wix.table_reservations.reservation_location.v1.ReservationLocationsService.UpdateReservationLocation',
            url: resolveWixTableReservationsReservationLocationV1ReservationLocationsServiceUrl({
                protoPath: '/v1/reservation-locations/{reservationLocation.id}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateReservationLocation.fromReq = fromReq;
    __updateReservationLocation.__isAmbassador = true;
    return __updateReservationLocation;
}
/** Updates the extended fields of a reservation location without incrementing the revision number. */
export function updateExtendedFields(payload) {
    var _a = serializer(_updateExtendedFieldsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateExtendedFieldsResponse, {
        _address: _address,
        _addressLocation: _addressLocation,
        _location: _location,
        _reservationLocation: _reservationLocation,
    }).fromJSON;
    function __updateExtendedFields(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.table_reservations.v1.reservation_location',
            method: 'POST',
            methodFqn: 'wix.table_reservations.reservation_location.v1.ReservationLocationsService.UpdateExtendedFields',
            url: resolveWixTableReservationsReservationLocationV1ReservationLocationsServiceUrl({
                protoPath: '/v1/reservation-locations/{id}/update-extended-fields',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateExtendedFields.fromReq = fromReq;
    __updateExtendedFields.__isAmbassador = true;
    return __updateExtendedFields;
}
/**
 * Retrieves a list of reservation locations given the provided paging, filtering, and sorting. Up to 100 reservation locations can be returned per request.
 *
 * For a detailed list of supported operations, see the Supported Filters and Sorting article.
 * To learn how to query reservation locations, see [API Query Language](https://dev.wix.com/api/rest/getting-started/api-query-language).
 */
export function queryReservationLocations(payload) {
    var _a = serializer(_queryReservationLocationsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_queryReservationLocationsResponse, {
        _address: _address,
        _addressLocation: _addressLocation,
        _location: _location,
        _reservationLocation: _reservationLocation,
    }).fromJSON;
    function __queryReservationLocations(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.table_reservations.v1.reservation_location',
            method: 'POST',
            methodFqn: 'wix.table_reservations.reservation_location.v1.ReservationLocationsService.QueryReservationLocations',
            url: resolveWixTableReservationsReservationLocationV1ReservationLocationsServiceUrl({
                protoPath: '/v1/reservation-locations/query',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __queryReservationLocations.fromReq = fromReq;
    __queryReservationLocations.__isAmbassador = true;
    return __queryReservationLocations;
}
/** Retrieves a list of up to 100 reservation locations. */
export function listReservationLocations(payload) {
    var _a = serializer(_listReservationLocationsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_listReservationLocationsResponse, {
        _address: _address,
        _addressLocation: _addressLocation,
        _location: _location,
        _reservationLocation: _reservationLocation,
    }).fromJSON;
    function __listReservationLocations(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.table_reservations.v1.reservation_location',
            method: 'GET',
            methodFqn: 'wix.table_reservations.reservation_location.v1.ReservationLocationsService.ListReservationLocations',
            url: resolveWixTableReservationsReservationLocationV1ReservationLocationsServiceUrl({ protoPath: '/v1/reservation-locations', data: serializedData, host: host }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __listReservationLocations.fromReq = fromReq;
    __listReservationLocations.__isAmbassador = true;
    return __listReservationLocations;
}
//# sourceMappingURL=http.impl.js.map